// ブラウザのJSXの親クラス.
import * as React from 'react';
import { User, Male, Female } from '../../constants/UserListField';
import * as HomeVisit from '../../constants/HomeVisit';
import { convertHomeVisitDate } from '../../utils/dateUtil';
import { CARE_LEVELS } from '../../constants/Training';
import * as Enumerable from 'linq';

interface BaseBrowserProps extends React.Props<{}> {
  moffAPI: any;
  total: number;
}

export class BaseBrowser extends React.Component<BaseBrowserProps, {}> {
  user: User;
  homeVisit: HomeVisit.ResnposeData;

  // 全体のシーケンス数.
  total: number;

  // 利用者氏名.
  userName: string;

  // 生年.
  birthYear: string;

  // 性別.
  gender: number;

  // 訪問日.
  visitDate: string;

  // 要介護度.
  careLevel: string;

  // 訪問スタッフ
  visitStaff: string;

  // 職種.
  profession: string;
  
  // 被聞き取り者.
  listenedUser: string;

  renderCSS(): JSX.Element {
    return (<div />);
  }

  /**
   * 更新
   */
  refresh() {
    // 利用者氏名.
    if (this.user) {
      this.userName = this.user.user_name;

      // 生年.
      this.birthYear = this.user.user_birth_year;

      // 性別.
      this.gender = this.user.user_gender;

      // 要介護度.
      const careLevel = this.user.user_care_level;
      this.careLevel = CARE_LEVELS[careLevel];
    }

    if (this.homeVisit) {
      // 訪問日.
      const tmpDate = this.homeVisit.visited_day ? convertHomeVisitDate(this.homeVisit.visited_day) : '';
      this.visitDate = tmpDate;

      // 訪問スタッフ
      this.visitStaff = this.homeVisit.staff;

      // 職種.
      this.profession = this.homeVisit.profession;
      
      // 被聞き取り者.
      this.listenedUser = this.homeVisit.interviewee;
    }
  }

  /**
   * 上段用(ADL/IADL)の各項目のJSXの描画.
   * @method renderTopSection
   * @param {Boolean} isBottom 最終行(bottomCellが入るため).
   * @param {String} itemName 項目タイトル名.
   * @param {HomeVisit.Multiple} multiple 連想配列.
   * @return {JSX.Element[]} JSXの配列.
   */
  renderTopSection(isBottom: boolean, itemName: string, multiple: HomeVisit.Multiple)
    : JSX.Element {
    // multipleを分離.
    // レベルの内容の配列(自立=0、見守り=1、一部介助=2、全介助=3).
    let levels: number[] = [];
    // 課題の有無.
    let isProblem: boolean = false;

    // 環境(実施場所、補助具など)(falseなら下段なので非表示).
    let env: boolean|string =  false;

    if (multiple) {
      levels = multiple ? multiple.level : [];
      isProblem = multiple ? multiple.is_problem : false;
      env = (multiple.env === undefined) ? false : multiple.env;
    }

    // number[] -> boolean[]
    const levelsBools: boolean[] = Enumerable.range(0, 4).select((i: number) => {
      return (levels.indexOf(i) > -1);
    }).toArray();

    const check = (isCheck: boolean): string => {
      return isCheck ? '■' : '□';
    };

    const problem: string = isProblem ? '有' : '無';

    const bottomTag: string = isBottom ? 'bottomCell ' : '';

    return (
      <div className="topSectionIntable">
        <div className={`${bottomTag}centerAlign sectionUpCell1`}>
          {itemName}
        </div>
        <div className={`${bottomTag}sectionUpCell2`}>
          <div className="levelTable">
            <div className="levelItem">
              {check(levelsBools[0])} 自立
            </div>
            <div className="levelItem">
              {check(levelsBools[1])} 見守り
            </div>
          </div>
          <div className="levelTable">
            <div className="levelItem">
              {check(levelsBools[2])} 一部介助
            </div>
            <div className="levelItem">
              {check(levelsBools[3])} 全介助
            </div>
          </div>
        </div>
        <div className={`${bottomTag}centerAlign sectionUpCell3`}>
          {problem}
        </div>
        <div className={`${bottomTag}leftStack sectionUpCell4`}>{env}</div>
      </div>);
  }

  /**
   * 下段用(起居動作)各項目のJSXの描画.
   * @method renderBottomSection
   * @param {String} itemName 項目タイトル名.
   * @param {HomeVisit.Multiple} multiple 連想配列.
   * @return {JSX.Element[]} JSXの配列.
   */
  renderBottomSection(itemName: string, multiple: HomeVisit.Multiple): JSX.Element {
    // multipleを分離.
    // レベルの内容の配列(自立=0、見守り=1、一部介助=2、全介助=3).
    let levels: number[] = [];
    // 課題の有無.
    let isProblem: boolean = false;

    if (multiple) {
      levels = multiple ? multiple.level : [];
      isProblem = multiple ? multiple.is_problem : false;
    }

    // number[] -> boolean[]
    const levelsBools: boolean[] = Enumerable.range(0, 4).select((i: number) => {
      return (levels.indexOf(i) > -1);
    }).toArray();

    const check = (isCheck: boolean): string => {
      return isCheck ? '■' : '□';
    };

    const problem: string = isProblem ? '有' : '無';

    return (
      <div className="kikyoSectionIntable">
        <div className="firstCell centerAlign sectionBottomCell1">
          {itemName}
        </div>
        <div className="sectionBottomCell2">
          <div className="levelTable">
            <div className="levelItem">
              {check(levelsBools[0])} 自立
            </div>
            <div className="levelItem">
              {check(levelsBools[1])} 見守り
            </div>
          </div>
          <div className="levelTable">
            <div className="levelItem">
              {check(levelsBools[2])} 一部介助
            </div>
            <div className="levelItem">
              {check(levelsBools[3])} 全介助
            </div>
          </div>
        </div>
        <div className="centerAlign sectionBottomCell3">
          {problem}
        </div>
      </div>);
  }

  render() {
    if (this.props.moffAPI.result === undefined) {
      return (null);
    }

    this.homeVisit = this.props.moffAPI.result.homeVisit;
    this.user = this.props.moffAPI.result.user;
    this.refresh();

    return (
      <div className="table">
        <div className="row" />
        <div className="row rowTop">
          <div className="titleName">
            居宅訪問チェックシート
          </div>
        </div>
        {/* <!-- 利用者情報 --> */}
        <div className="row row1">
          <div className="intable">
            <div className="centerAlign firstCell topCell bgColor cell3_5">
              利用者氏名
            </div>
            <div className="centerAlign topCell cell3_5">
              {this.userName}
            </div>
            <div className="centerAlign bgColor topCell cell2">
              生年
            </div>
            <div className="birthYearAlign leftStack cell3 topCell">
              {this.birthYear}年
            </div>
            <div className="ageAlign cell1_5 topCell">
              歳
            </div>
            <div className="centerAlign bgColor topCell cell1_5">
              性別
            </div>
            <div className="centerAlign cell2 topCell lastCell">
              {this.gender === 0 ? Male : Female}
            </div>
          </div>
        </div>
        {/* <!-- 2行目 --> */}
        <div className="row row1">
          <div className="intable">
            <div className="centerAlign firstCell bgColor cell3_5">
              訪問日
            </div>
            <div className="centerAlign cell9_5">
              {this.visitDate}
            </div>
            <div className="centerAlign bgColor cell2">
              要介護度
            </div>
            <div className="centerAlign lastCell cell2">
              {this.careLevel}
            </div>
          </div>
        </div>
        {/* <!-- 3行目 --> */}
        <div className="row row1">
          <div className="intable">
            <div className="centerAlign firstCell bottomCell bgColor cell3_5">
              訪問スタッフ
            </div>
            <div className="centerAlign cell3_5 bottomCell">
              {this.visitStaff}
            </div>
            <div className="centerAlign bgColor cell2 bottomCell">
              職種
            </div>
            <div className="centerAlign cell4 bottomCell">
              {this.profession}
            </div>
            <div className="centerAlign bgColor cell2 bottomCell">
              被聞き取り者
            </div>
            <div className="centerAlign lastCell cell2 bottomCell">
              {this.listenedUser}
            </div>
          </div>
        </div>
        {/* <!-- blank --> */}
        <div className="row blankRow">
          <div className="intable">
            <div className="blankCell" />
          </div>
        </div>
        {/* <!-- 内容タイトル --> */}
        <div className="row row1">
          <div className="intable">
            <div className="firstCell topCell bgColor sectionTitle1">
              {/* <!-- 空白 --> */}
            </div>
            <div className="centerAlign bgColor topCell sectionTitle2">
              項目
            </div>
            <div className="centerAlign bgColor topCell sectionTitle3">
              レベル
            </div>
            <div className="centerAlign bgColor topCell sectionTitle4">
              課題
            </div>
            <div className="centerAlign bgColor topCell sectionTitle5">
              環境(実施場所、補助具など)
            </div>
            <div className="centerAlign lastCell bgColor topCell sectionTitle6">
              状況・生活課題
            </div>
          </div>
        </div>
        {/* <!-- ADL --> */}
        <div className="row rowADL">
          <div className="intable">
            <div className="centerAlign firstCell secTitleCell2">
              ADL
            </div>
            <div className="chaptersCell">
              {/* <!-- 各項目 --> */}
              {/* ADL */}
              {this.renderTopSection(false, '食事', this.homeVisit.adl_feed)}
              {this.renderTopSection(false, '排尿', this.homeVisit.adl_ur)}
              {this.renderTopSection(false, '入浴', this.homeVisit.adl_bath)}
              {this.renderTopSection(false, '更衣', this.homeVisit.adl_dress)}
              {this.renderTopSection(false, '整容', this.homeVisit.adl_cosme)}
              {this.renderTopSection(true, '移乗', this.homeVisit.adl_transfer)}
            </div>
            <div className="leftUpStack adlCell4 lastCell">
              {/* <!-- 状況・生活課題 --> */}
              {this.homeVisit.adl_detail}
            </div>
          </div>
        </div>
        {/* <!-- IADL --> */}
        <div className="row rowIADL">
          <div className="intable">
            <div className="centerAlign firstCell secIADLTitleCell2">
              IADL
            </div>
            <div className="chaptersCell">
              {/* <!-- 各項目 --> */}
              {/* IADL */}
              {this.renderTopSection(false, '屋内移動', this.homeVisit.iadl_indoor)}
              {this.renderTopSection(false, '屋外移動', this.homeVisit.iadl_outdoor)}
              {this.renderTopSection(false, '階段昇降', this.homeVisit.iadl_lift)}
              {this.renderTopSection(false, '調理', this.homeVisit.iadl_cook)}
              {this.renderTopSection(false, '洗濯', this.homeVisit.iadl_wash)}
              {this.renderTopSection(true, '掃除', this.homeVisit.iadl_clean)}
            </div>
            <div className="leftUpStack iadlCell4 lastCell">
              {/* <!-- 状況・生活課題 --> */}
              {this.homeVisit.iadl_detail}
            </div>
          </div>
        </div>
        {/* <!-- 起居動作・タイトル --> */}
        <div className="row row1">
          <div className="intable">
            <div className="bgColor firstCell sectionTitle1">
              {/* <!-- 空白 --> */}
            </div>
            <div className="centerAlign bgColor sectionTitle2">
              項目
            </div>
            <div className="centerAlign bgColor sectionTitle3">
              レベル
            </div>
            <div className="centerAlign bgColor sectionTitle4">
              課題
            </div>
            <div className="centerAlign bgColor cell8 sectionTitle7">
              状況・生活課題
            </div>
          </div>
        </div>
        {/* <!-- 起居動作 --> */}
        <div className="row rowKikyo">
          <div className="intable">
            <div className="centerAlign firstCell secTitleCell2 bottomCell">
              起居動作
            </div>
            <div className="chaptersBottomCell bottomCell">
              {/* <!-- 各項目 --> */}
              {/* 起居動作 */}
              {this.renderBottomSection('起き上がり', this.homeVisit.behaivior_arise)}
              {this.renderBottomSection('座位', this.homeVisit.behaivior_sitting)}
              {this.renderBottomSection('立ち上がり', this.homeVisit.behaivior_standup)}
              {this.renderBottomSection('立位', this.homeVisit.behaivior_upright)}
            </div>
            <div className="leftUpStack cell8 lastCell bottomCell">
              {/* <!-- 状況・生活課題 --> */}
              {this.homeVisit.behaivior_detail}
            </div>
          </div>
        </div>
        {this.renderCSS()}
      </div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/HomeVisitPrintBrowsers/BaseBrowser.tsx